import { IChatReceipt, ICreateChat, ICreateChatMessage,
    IInviteMember, IRequestChatMessages, IToxicCheck, IChatAlteration, ILocallyStoredMsg,
    ICreateChatMessageAction, IRequestMessageReadInfo, IChatCheckIn} from '@app-types/websocket/chat.types';
import { createAction } from 'redux-act';

export const createChat = createAction<ICreateChat>('Create new chat');

export const localSaveChatMessage = createAction<ILocallyStoredMsg>('Local save chat message');

export const createChatMessage = createAction<ICreateChatMessage>('Create chat message');

export const createChatMessageToxicChecked = createAction<ICreateChatMessage>('Create chat message with toxic check');

export const createChatMessageToxicCheckedAction = createAction<ICreateChatMessageAction>('Action on toxic checked message');

export const chatCheckIn = createAction<IChatCheckIn>('Check in to chat');

export const toxicCheck = createAction<IToxicCheck>('Check chat message');

export const inviteMember = createAction<IInviteMember>('Invite family member to chat');

export const requestChatMessages = createAction<IRequestChatMessages>('Request chat messages');

export const requestMessageReadInfo = createAction<IRequestMessageReadInfo>('Request message read info');

export const sendChatReadReceipt = createAction<IChatReceipt>('Send chat read receipt');

export const archiveChat = createAction<number>('Archive chat');

export const renameChat = createAction<IChatAlteration>('Rename chat');

export const clearChat = createAction<boolean>('clear chat history');

export const saveChat = createAction<number>('save chat history');



// WEBPACK FOOTER //
// ./src/services/chat/chat.actions.ts